/**
 * BabyBoom Product Page JS
 * Consolidated for performance
 */
(function () {
  function getMoneyFormat() {
    if (window.BabyBoomMoneyFormat) return window.BabyBoomMoneyFormat;
    if (window.Shopify && window.Shopify.money_format) return window.Shopify.money_format;
    return "${{amount}}";
  }

  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    let value = '';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = getMoneyFormat();

    function defaultOption(opt, def) { return (typeof opt == 'undefined' ? def : opt); }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      const parts = number.split('.');
      const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      const centsAmount = parts[1] ? (decimal + parts[1]) : '';
      return dollarsAmount + centsAmount;
    }

    const match = formatString.match(placeholderRegex);
    if (!match) return cents;
    switch (match[1]) {
      case 'amount': value = formatWithDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
      default: value = formatWithDelimiters(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
  }

  function setupPickupDrawer(pickupContainer) {
    const trigger = pickupContainer.querySelector('.pickup-details-trigger');
    const drawer = pickupContainer.querySelector('.pickup-availability-drawer');
    const closeBtn = pickupContainer.querySelector('.pickup-drawer-close');
    const backdrop = pickupContainer.querySelector('.pickup-drawer-backdrop');
    
    if (trigger && drawer) {
      trigger.addEventListener('click', () => {
        document.body.appendChild(drawer);
        drawer.classList.add('active');
        drawer.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('no-scroll');
      });
    }
    
    const closeDrawer = () => {
      if (drawer) {
        drawer.classList.remove('active');
        drawer.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('no-scroll');
        pickupContainer.appendChild(drawer);
      }
    };
    
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (backdrop) backdrop.addEventListener('click', closeDrawer);
  }

  function fetchPickupAvailability(container, variantId, isAvailable) {
    const pickupContainer = container.querySelector('.pickup-availability-container');
    if (!pickupContainer) return;
    const rootUrl = pickupContainer.dataset.rootUrl || '/';
    pickupContainer.dataset.variantId = variantId;

    const renderFallback = () => {
      const shopName = pickupContainer.dataset.shopName || 'Shop';
      const shopAddress = pickupContainer.dataset.shopAddress || '';
      const productTitle = pickupContainer.dataset.productTitle || '';

      if (isAvailable) {
        pickupContainer.innerHTML = `
          <div class="pickup-availability-preview">
            <span class="pickup-icon available">✓</span>
            <div class="pickup-text">
              <p class="pickup-title">Pickup available at <strong>${shopName}</strong></p>
              <p class="pickup-time">Usually ready in 24 hours</p>
              <button type="button" class="pickup-details-trigger" aria-haspopup="dialog">Check store availability</button>
            </div>
          </div>
          <div class="pickup-availability-drawer" id="PickupDrawer-${variantId}" aria-hidden="true">
            <div class="pickup-drawer-backdrop"></div>
            <div class="pickup-drawer-content">
              <div class="pickup-drawer-header">
                <h2 class="pickup-drawer-heading">${productTitle}</h2>
                <button type="button" class="pickup-drawer-close" aria-label="Close">×</button>
              </div>
              <ul class="pickup-drawer-list" role="list">
                <li class="pickup-drawer-item">
                  <h3 class="pickup-location-name">${shopName}</h3>
                  <div class="pickup-location-status">
                    <span class="pickup-status-available">✓ Available for pickup</span>
                  </div>
                  <p class="pickup-location-time">Usually ready in 24 hours</p>
                  <address class="pickup-location-address">
                    ${shopAddress}
                  </address>
                </li>
              </ul>
            </div>
          </div>
        `;
        setupPickupDrawer(pickupContainer);
      } else {
        pickupContainer.innerHTML = `
          <div class="pickup-availability-preview">
            <span class="pickup-icon unavailable">✗</span>
            <div class="pickup-text">
              <p class="pickup-title">Pickup currently unavailable</p>
              <p class="pickup-time">Out of stock</p>
            </div>
          </div>
        `;
      }
    };

    fetch(`${rootUrl}variants/${variantId}/?section_id=pickup-availability`)
      .then(response => {
        if (!response.ok) return '';
        return response.text();
      })
      .then(html => {
        if (html.trim() === '' || !html.includes('pickup-availability-info')) {
          renderFallback();
          return;
        }
        pickupContainer.innerHTML = html;
        setupPickupDrawer(pickupContainer);
      })
      .catch(err => {
        console.error('Error fetching pickup availability:', err);
        renderFallback();
      });
  }

  function initProduct(section) {
    if (!section || section.dataset.initialized === 'true') return;
    section.dataset.initialized = 'true';
    initSwatches(section);

    section.addEventListener('click', (e) => handleProductClick(e, section));

    const sectionId = section.dataset.sectionId;
    const jsonElement = document.getElementById(`ProductJson-${sectionId}`);
    if (jsonElement) {
      try {
        const productData = JSON.parse(jsonElement.innerHTML);
        const initialVariant = productData.variants[0];
        const idInput = section.querySelector('input[name="id"]');
        const initialVariantId = idInput ? idInput.value : (initialVariant ? initialVariant.id : null);
        if (initialVariantId) {
          const initialVariantObj = productData.variants.find(v => v.id.toString() === initialVariantId.toString()) || initialVariant;
          fetchPickupAvailability(section, initialVariantId, initialVariantObj ? initialVariantObj.available : true);
        }
      } catch (e) {
        console.error(e);
      }
    }
  }

  function initSwatches(container) {
    if (window.BabyBoomInitSwatches) {
      window.BabyBoomInitSwatches(container);
    }
  }

  function updateVariantUI(container, variant) {
    if (!variant) return;

    const idInput = container.querySelector('input[name="id"]');
    if (idInput) idInput.value = variant.id;

    const priceMain = container.querySelector('.price-main');
    if (priceMain) priceMain.textContent = formatMoney(variant.price);

    const priceCompare = container.querySelector('.price-compare');
    if (priceCompare) {
      if (variant.compare_at_price > variant.price) {
        priceCompare.textContent = formatMoney(variant.compare_at_price);
        priceCompare.style.display = 'block';
      } else {
        priceCompare.style.display = 'none';
      }
    }

    const atcBtn = container.querySelector('.add-to-cart-btn');
    if (atcBtn) {
      atcBtn.disabled = !variant.available;
      const btnSpan = atcBtn.querySelector('span');
      if (btnSpan) btnSpan.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
    }

    const paymentBtnWrapper = container.querySelector('.shopify-payment-button-wrapper');
    if (paymentBtnWrapper) {
      if (variant.available) {
        paymentBtnWrapper.classList.remove('disabled');
      } else {
        paymentBtnWrapper.classList.add('disabled');
      }
    }

    fetchPickupAvailability(container, variant.id, variant.available);

    // Update SKU dynamically on variant change
    const skuVal = variant.sku || '';
    const skuElements = document.querySelectorAll('.js-product-sku');
    skuElements.forEach(el => {
      el.textContent = skuVal || 'N/A';
      const row = el.closest('.js-product-sku-row');
      if (row) {
        row.style.display = skuVal ? '' : 'none';
      }
    });


    let targetThumb = null;
    const section = container.closest('[id^="ProductSection-"]');

    // 1. Try featured media/image
    if (variant.featured_media || variant.featured_image) {
      const mediaId = variant.featured_media ? variant.featured_media.id : variant.featured_image.id;
      targetThumb = section.querySelector(`.thumbnail[data-media-id="${mediaId}"]`);
    }
    // 2. Fallback: Try matching color name to image alt text, or by index mapping
    else {
      const colorOptIndex = variant.options.findIndex((opt, i) => {
        const group = container.querySelectorAll('.option-group')[i];
        return group && (group.querySelector('.option-label').textContent.toLowerCase().includes('color') ||
          group.querySelector('.option-label').textContent.toLowerCase().includes('colour'));
      });

      if (colorOptIndex >= 0) {
        const colorValue = variant.options[colorOptIndex];
        const thumbnails = Array.from(section.querySelectorAll('.thumbnail'));

        // Try alt text match
        targetThumb = thumbnails.find(t => {
          const img = t.querySelector('img');
          return img && img.alt && img.alt.toLowerCase().includes(colorValue.toLowerCase());
        });

        // Try index match
        if (!targetThumb) {
          const group = container.querySelectorAll('.option-group')[colorOptIndex];
          const colorBtns = Array.from(group.querySelectorAll('.option-value-btn'));
          const valueIndex = colorBtns.findIndex(b => b.dataset.value === colorValue);
          if (valueIndex >= 0 && valueIndex < thumbnails.length) {
            targetThumb = thumbnails[valueIndex];
          }
        }
      }
    }

    if (targetThumb) {
      const targetMediaId = targetThumb.dataset.mediaId || targetThumb.dataset.imageId;
      const thumbnails = container.querySelectorAll('.thumbnail');
      thumbnails.forEach(t => t.classList.remove('active'));
      targetThumb.classList.add('active');
      
      const mediaItems = container.querySelectorAll('.media-item');
      if (mediaItems.length > 0) {
        mediaItems.forEach(item => {
          if (item.dataset.mediaId === targetMediaId) {
             item.classList.add('active');
             item.style.display = '';
             const vid = item.querySelector('video');
             if(vid) vid.play();
          } else {
             item.classList.remove('active');
             item.style.display = 'none';
             const vid = item.querySelector('video');
             if(vid) vid.pause();
          }
        });
      } else {
        const mainImage = container.querySelector('img[id^="MainImage-"]');
        if (mainImage && targetThumb.dataset.src) {
          mainImage.src = targetThumb.dataset.src;
          mainImage.removeAttribute('srcset');
        }
      }
    }
  }

  function handleProductClick(e, section) {
    const target = e.target;
    const sectionId = section.dataset.sectionId;
    const jsonElement = document.getElementById(`ProductJson-${sectionId}`);
    if (!jsonElement) return;
    const productData = JSON.parse(jsonElement.innerHTML);

    // 1. Option Selector
    const optionBtn = target.closest('.option-value-btn');
    if (optionBtn) {
      const optionGroup = optionBtn.closest('.option-group');
      const blockContainer = optionBtn.closest('.product-layout');

      optionGroup.querySelectorAll('.option-value-btn').forEach(b => b.classList.remove('active'));
      optionBtn.classList.add('active');

      const selectedOptions = Array.from(blockContainer.querySelectorAll('.option-group'))
        .map(group => {
          const active = group.querySelector('.option-value-btn.active');
          return active ? active.getAttribute('data-value') : null;
        });

      const variant = productData.variants.find(v => {
        return v.options.every((opt, i) => opt === selectedOptions[i]);
      });

      if (variant) updateVariantUI(blockContainer, variant);
    }

    // 2. Thumbnail Switcher
    const thumb = target.closest('.thumbnail');
    if (thumb) {
      const blockContainer = thumb.closest('.product-layout');
      const thumbnails = blockContainer.querySelectorAll('.thumbnail');

      thumbnails.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      
      const targetMediaId = thumb.dataset.mediaId || thumb.dataset.imageId;
      const mediaItems = blockContainer.querySelectorAll('.media-item');
      if (mediaItems.length > 0) {
        mediaItems.forEach(item => {
          if (item.dataset.mediaId === targetMediaId) {
             item.classList.add('active');
             item.style.display = '';
             const vid = item.querySelector('video');
             if(vid) vid.play();
          } else {
             item.classList.remove('active');
             item.style.display = 'none';
             const vid = item.querySelector('video');
             if(vid) vid.pause();
          }
        });
      } else {
        const mainImage = blockContainer.querySelector('img[id^="MainImage-"]');
        if (mainImage && thumb.dataset.src) {
          mainImage.src = thumb.dataset.src;
          mainImage.removeAttribute('srcset');
        }
      }

      const imageId = thumb.dataset.mediaId || thumb.dataset.imageId;
      let variant = productData.variants.find(v => v.featured_image && v.featured_image.id.toString() === imageId.toString());

      // Fallback: If no variant explicitly has this image, try index mapping for colors
      if (!variant) {
        const thumbIndex = Array.from(thumbnails).indexOf(thumb);
        const colorGroupIndex = Array.from(blockContainer.querySelectorAll('.option-group')).findIndex(g => {
          return g.querySelector('.option-label').textContent.toLowerCase().includes('color') ||
            g.querySelector('.option-label').textContent.toLowerCase().includes('colour');
        });

        if (colorGroupIndex >= 0) {
          const colorGroup = blockContainer.querySelectorAll('.option-group')[colorGroupIndex];
          const colorBtns = colorGroup.querySelectorAll('.option-value-btn');

          if (thumbIndex < colorBtns.length) {
            const matchedColorBtn = colorBtns[thumbIndex];
            const matchedColor = matchedColorBtn.dataset.value;

            // Get currently selected options
            const selectedOptions = Array.from(blockContainer.querySelectorAll('.option-group')).map((group, i) => {
              if (i === colorGroupIndex) return matchedColor;
              const active = group.querySelector('.option-value-btn.active');
              return active ? active.getAttribute('data-value') : null;
            });

            variant = productData.variants.find(v => v.options.every((opt, i) => opt === selectedOptions[i]));
          }
        }
      }

      if (variant) {
        variant.options.forEach((optVal, i) => {
          const groups = blockContainer.querySelectorAll('.option-group');
          if (groups[i]) {
            const btn = groups[i].querySelector(`.option-value-btn[data-value="${optVal}"]`);
            if (btn) {
              groups[i].querySelectorAll('.option-value-btn').forEach(b => b.classList.remove('active'));
              btn.classList.add('active');
            }
          }
        });
        updateVariantUI(blockContainer, variant);
      }
    }

    // 2.5 Main Image Carousel Navigation
    const navBtn = target.closest('.main-image-nav');
    if (navBtn) {
      const blockContainer = navBtn.closest('.product-layout');
      const thumbnails = Array.from(blockContainer.querySelectorAll('.thumbnail'));
      if (thumbnails.length > 0) {
        const currentIndex = thumbnails.findIndex(t => t.classList.contains('active'));
        let newIndex = currentIndex;

        if (navBtn.classList.contains('prev')) {
          newIndex = currentIndex > 0 ? currentIndex - 1 : thumbnails.length - 1;
        } else if (navBtn.classList.contains('next')) {
          newIndex = currentIndex < thumbnails.length - 1 ? currentIndex + 1 : 0;
        }

        if (newIndex !== currentIndex) {
          // Simulate click on the target thumbnail to reuse its logic (updates main image + variants)
          thumbnails[newIndex].click();
        }
      }
    }

    // 3. Zoom, Quantity, ATC
    // Open lightbox when zoom trigger or main image is clicked
    if (target.closest('[id^="ZoomTrigger-"]') || target.closest('.media-item.active img')) {
      const block = target.closest('.product-layout');
      if (!block) return;
      const activeThumb = block.querySelector('.thumbnail.active');
      if (activeThumb) {
        openBBLightbox(activeThumb.dataset.src, block);
      }
    }

    const qtyBtn = target.closest('[id^="QtyPlus-"], [id^="QtyMinus-"]');
    if (qtyBtn) {
      const block = qtyBtn.closest('.product-layout');
      const input = block.querySelector('[id^="Quantity-"]');
      if (input) {
        const val = parseInt(input.value);
        if (qtyBtn.id.includes('QtyPlus')) input.value = val + 1;
        else if (val > 1) input.value = val - 1;
      }
    }

    if (target.closest('.js-ajax-add-to-cart')) {
      e.preventDefault();
      const btn = target.closest('.js-ajax-add-to-cart');
      const form = btn.closest('form');
      btn.disabled = true;
      const original = btn.innerHTML;
      btn.innerHTML = '<span>Adding...</span>';
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
        .then(r => r.json())
        .then(() => {
          btn.disabled = false; btn.innerHTML = original;
          const d = document.getElementById('cart-drawer');
          if (d) { d.classList.add('is-open'); document.documentElement.classList.add('no-scroll'); if (window.refreshCartDrawer) window.refreshCartDrawer(); }
        })
        .catch(() => { btn.disabled = false; btn.innerHTML = original; });
    }
  }

  // =====================================================================
  // BB PREMIUM LIGHTBOX ENGINE
  // Features: scroll-zoom, drag-pan, pinch-to-zoom, swipe-nav, keyboard
  // =====================================================================
  (function initBBLightbox() {
    const lb = document.getElementById('BBLightbox');
    const lbImg = document.getElementById('BBLightboxImg');
    const lbPrev = document.getElementById('BBLightboxPrev');
    const lbNext = document.getElementById('BBLightboxNext');
    const lbClose = document.getElementById('BBLightboxClose');
    const lbCounter = document.getElementById('BBLightboxCounter');
    const lbThumbs = document.getElementById('BBLightboxThumbs');
    const lbZoomIn = document.getElementById('BBLightboxZoomIn');
    const lbZoomOut = document.getElementById('BBLightboxZoomOut');
    const lbZoomRst = document.getElementById('BBLightboxZoomReset');
    const stage = document.getElementById('BBLightboxStage');

    if (!lb || !lbImg) return;

    let images = [];   // [{src, thumb}]
    let current = 0;
    let scale = 1;
    let panX = 0;
    let panY = 0;
    let isDragging = false;
    let dragStartX = 0;
    let dragStartY = 0;
    let panStartX = 0;
    let panStartY = 0;

    // ---- Helpers ----
    function applyTransform(animate) {
      lbImg.style.transition = animate ? 'transform 0.25s ease' : 'none';
      lbImg.style.transform = `translate(${panX}px, ${panY}px) scale(${scale})`;
    }

    function resetZoomPan(animate) {
      scale = 1; panX = 0; panY = 0;
      applyTransform(animate);
    }

    function setScale(s, animate) {
      scale = Math.min(5, Math.max(1, s));
      if (scale === 1) { panX = 0; panY = 0; }
      applyTransform(animate);
    }

    function updateCounter() {
      if (lbCounter) lbCounter.textContent = `${current + 1} / ${images.length}`;
    }

    function showImage(index, fade) {
      if (!images.length) return;
      current = (index + images.length) % images.length;

      const goTo = () => {
        const media = images[current];
        const lbVideo = document.getElementById('BBLightboxVideo');
        
        if (media.type === 'video') {
           lbImg.style.display = 'none';
           if (lbVideo) {
             lbVideo.style.display = 'block';
             lbVideo.src = media.src;
             lbVideo.play().catch(e => console.error('Video play error:', e));
           }
        } else {
           if (lbVideo) {
             lbVideo.style.display = 'none';
             lbVideo.pause();
           }
           lbImg.style.display = 'block';
           lbImg.src = media.src;
        }
        
        resetZoomPan(false);
        updateCounter();
        syncThumbs();
        // hide arrows if only 1 image
        const hide = images.length < 2;
        if (lbPrev) lbPrev.style.display = hide ? 'none' : '';
        if (lbNext) lbNext.style.display = hide ? 'none' : '';
      };

      if (fade) {
        lbImg.classList.add('is-fading');
        setTimeout(() => { goTo(); lbImg.classList.remove('is-fading'); }, 180);
      } else { goTo(); }
    }

    function buildThumbs() {
      if (!lbThumbs) return;
      lbThumbs.innerHTML = '';
      images.forEach((im, i) => {
        const div = document.createElement('div');
        div.className = 'bb-lightbox__thumb' + (i === current ? ' is-active' : '');
        div.innerHTML = `<img src="${im.thumb}" alt="" loading="lazy">`;
        div.addEventListener('click', () => showImage(i, true));
        lbThumbs.appendChild(div);
      });
    }

    function syncThumbs() {
      if (!lbThumbs) return;
      lbThumbs.querySelectorAll('.bb-lightbox__thumb').forEach((t, i) => {
        t.classList.toggle('is-active', i === current);
      });
      const active = lbThumbs.children[current];
      if (active) active.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }

    // ---- Public opener ----
    window.openBBLightbox = function (clickedSrc, block) {
      // Gather all media from the product-layout block
      images = [];
      const thumbEls = block ? block.querySelectorAll('.thumbnail') : [];
      if (thumbEls.length > 0) {
        thumbEls.forEach(t => {
          const hi = t.dataset.src || '';
          const lo = t.querySelector('img') ? t.querySelector('img').src : hi;
          images.push({ src: hi || lo, thumb: lo, type: t.dataset.mediaType });
        });
        // Set current index to match clicked media
        current = 0;
        images.forEach((im, i) => { if (im.src && clickedSrc && im.src.split('?')[0] === clickedSrc.split('?')[0]) current = i; });
      } else {
        images = [{ src: clickedSrc, thumb: clickedSrc, type: 'image' }];
        current = 0;
      }

      buildThumbs();
      showImage(current, false);
      lb.classList.add('is-open');
      document.documentElement.classList.add('no-scroll');
      document.body.style.overflow = 'hidden';
    };

      // ---- Close ----
    function closeLightbox() {
      lb.classList.remove('is-open');
      document.documentElement.classList.remove('no-scroll');
      document.body.style.overflow = '';
      resetZoomPan(false);
      const lbVideo = document.getElementById('BBLightboxVideo');
      if(lbVideo) lbVideo.pause();
    }

    if (lbClose) lbClose.addEventListener('click', closeLightbox);
    lb.addEventListener('click', e => { if (e.target === lb) closeLightbox(); });

    // ---- Prev / Next ----
    if (lbPrev) lbPrev.addEventListener('click', e => { e.stopPropagation(); showImage(current - 1, true); });
    if (lbNext) lbNext.addEventListener('click', e => { e.stopPropagation(); showImage(current + 1, true); });

    // ---- Zoom buttons ----
    if (lbZoomIn) lbZoomIn.addEventListener('click', () => setScale(scale + 0.5, true));
    if (lbZoomOut) lbZoomOut.addEventListener('click', () => setScale(scale - 0.5, true));
    if (lbZoomRst) lbZoomRst.addEventListener('click', () => resetZoomPan(true));

    // ---- Keyboard navigation ----
    document.addEventListener('keydown', e => {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft') showImage(current - 1, true);
      if (e.key === 'ArrowRight') showImage(current + 1, true);
      if (e.key === '+' || e.key === '=') setScale(scale + 0.5, true);
      if (e.key === '-') setScale(scale - 0.5, true);
    });

    // ---- Mouse scroll zoom ----
    if (stage) {
      stage.addEventListener('wheel', e => {
        if (!lb.classList.contains('is-open')) return;
        e.preventDefault();
        const delta = e.deltaY > 0 ? -0.2 : 0.2;
        setScale(scale + delta, false);
      }, { passive: false });

      // ---- Double click zoom ----
      stage.addEventListener('dblclick', e => {
        if (scale > 1) resetZoomPan(true);
        else setScale(2.5, true);
      });

      // ---- Mouse drag pan ----
      stage.addEventListener('mousedown', e => {
        if (scale <= 1) return;
        isDragging = true;
        dragStartX = e.clientX;
        dragStartY = e.clientY;
        panStartX = panX;
        panStartY = panY;
        stage.classList.add('is-grabbing');
      });
      document.addEventListener('mousemove', e => {
        if (!isDragging) return;
        panX = panStartX + (e.clientX - dragStartX);
        panY = panStartY + (e.clientY - dragStartY);
        applyTransform(false);
      });
      document.addEventListener('mouseup', () => {
        isDragging = false;
        stage.classList.remove('is-grabbing');
      });
    }

    // ---- Touch: swipe + pinch-to-zoom ----
    let touchStartX = 0;
    let touchStartY = 0;
    let lastDist = 0;
    let lastScale = 1;

    if (stage) {
      stage.addEventListener('touchstart', e => {
        if (e.touches.length === 1) {
          touchStartX = e.touches[0].clientX;
          touchStartY = e.touches[0].clientY;
          panStartX = panX;
          panStartY = panY;
        } else if (e.touches.length === 2) {
          const dx = e.touches[0].clientX - e.touches[1].clientX;
          const dy = e.touches[0].clientY - e.touches[1].clientY;
          lastDist = Math.hypot(dx, dy);
          lastScale = scale;
        }
      }, { passive: true });

      stage.addEventListener('touchmove', e => {
        if (e.touches.length === 2) {
          // Pinch
          const dx = e.touches[0].clientX - e.touches[1].clientX;
          const dy = e.touches[0].clientY - e.touches[1].clientY;
          const dist = Math.hypot(dx, dy);
          setScale(lastScale * (dist / lastDist), false);
        } else if (e.touches.length === 1 && scale > 1) {
          // Drag-pan when zoomed
          panX = panStartX + (e.touches[0].clientX - touchStartX);
          panY = panStartY + (e.touches[0].clientY - touchStartY);
          applyTransform(false);
        }
      }, { passive: true });

      stage.addEventListener('touchend', e => {
        if (e.changedTouches.length === 1 && scale <= 1) {
          // Swipe detection
          const dx = e.changedTouches[0].clientX - touchStartX;
          const dy = e.changedTouches[0].clientY - touchStartY;
          if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
            showImage(dx < 0 ? current + 1 : current - 1, true);
          }
        }
      }, { passive: true });
    }

    // ---- Keep thumbnail click on main image working ----
    document.addEventListener('click', e => {
      const mainImg = e.target.closest('.media-item.active img');
      if (mainImg) {
        const block = mainImg.closest('.product-layout');
        const activeThumb = block ? block.querySelector('.thumbnail.active') : null;
        if (block && activeThumb) {
          openBBLightbox(activeThumb.dataset.src, block);
        }
      }
    });
  })();

  // Legacy ZoomClose stub
  document.addEventListener('click', (e) => {
    if (e.target.closest('#ZoomClose')) {
      const m = document.getElementById('ZoomModal');
      if (m) m.style.display = 'none';
    }
  });

  function initAll() {
    const runInit = () => {
      document.querySelectorAll('[id^="ProductSection-"]').forEach(initProduct);
    };
    if (window.requestIdleCallback) {
      window.requestIdleCallback(runInit, { timeout: 1000 });
    } else {
      setTimeout(runInit, 50);
    }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initAll); }
  else { initAll(); }
  document.addEventListener('shopify:section:load', (e) => {
    const s = e.target.querySelector('[id^="ProductSection-"]');
    if (s) initProduct(s);
  });
})();

// Quick COD quantity totals: preserves existing controls and variant handlers.
(() => {
  function refreshQuantityTotals() {
    document.querySelectorAll('[id^="ProductJson-"]').forEach(json => {
      const sectionId = json.id.slice('ProductJson-'.length);
      const container = document.querySelector(`[data-section-id="${sectionId}"]`);
      if (!container || container.classList.contains('quick-cod')) return;
      let product; try { product = JSON.parse(json.textContent); } catch { return; }
      const quantity = Math.max(1, Number(container.querySelector('input[name="quantity"]')?.value || 1));
      const variantId = container.querySelector('[name="id"]')?.value;
      const variant = product.variants.find(v => String(v.id) === String(variantId)) || product.variants[0];
      if (!variant) return;
      const format = value => new Intl.NumberFormat('en-PK',{style:'currency',currency:window.Shopify?.currency?.active || 'PKR'}).format(value/100).replace('PKR','Rs.');
      const price = container.querySelector('.price-main');
      const compare = container.querySelector('.price-compare');
      const mainText = format(variant.price * quantity);
      if (price && price.textContent !== mainText) price.textContent = mainText;
      if (compare && variant.compare_at_price > variant.price) { const text = format(variant.compare_at_price * quantity); if (compare.textContent !== text) compare.textContent = text; }
    });
  }
  let scheduled = false;
  const schedule = () => { if (scheduled) return; scheduled = true; requestAnimationFrame(() => { scheduled = false; refreshQuantityTotals(); }); };
  document.addEventListener('input',schedule);
  document.addEventListener('change',schedule);
  document.addEventListener('click',schedule);
  document.addEventListener('shopify:section:load',schedule);
  document.addEventListener('DOMContentLoaded',schedule);
  // Handles theme scripts that assign input.value without emitting change.
  setInterval(refreshQuantityTotals,350);
  schedule();
})();
